import React, { useRef, useState } from 'react'
import { Camera } from 'expo-camera'
import { Button, StyleSheet, Text, TouchableOpacity, View, Image, ImageBackground } from 'react-native'
import * as MediaLibrary from 'expo-media-library'
import { useToast } from 'native-base'
import { useRecoilState } from 'recoil'
import { cameraState, imageState } from '../../state/atoms'
import { MaterialCommunityIcons } from '@expo/vector-icons'

export const UseCamera = () => {
    const cameraRef = useRef(null)
    const [permission, requestPermission] = Camera.useCameraPermissions()
    const [previewVisible, setPreviewVisible] = useState(false)
    const [capturedImage, setCapturedImage] = useState(null)
    const [camera, setCamera] = useRecoilState(cameraState)
    // Testing image to view system
    const [image, setImage] = useRecoilState(imageState)

    const toast = useToast()

    if (!permission) {
        // Camera permissions are still loading
        return <View />
    }

    if (!permission.granted) {
        // Camera permissions are not granted yet
        return (
            <View style={styles.container}>
                <Text style={{ textAlign: 'center' }}>We need your permission to show the camera</Text>
                <Button onPress={requestPermission} title="grant permission" />
            </View>
        )
    }

    const takePicture = async () => {
        if (!permission) return
        const photo = await cameraRef.current.takePictureAsync()
        setPreviewVisible(true)
        setCapturedImage(photo)
    }

    const retakePicture = () => {
        setCapturedImage(null)
        setPreviewVisible(false)
    }

    const savePicture = () => {
        MediaLibrary.saveToLibraryAsync(capturedImage.uri)
        setCapturedImage(null)
        setPreviewVisible(false)
        toast.show({ description: 'Saved to camera roll', placement: 'top' })
        setImage(capturedImage)
        setCamera(false)
    }
    return (
        <View style={styles.container}>
            {previewVisible && capturedImage ? (
                <View
                    style={{
                        backgroundColor: 'transparent',
                        flex: 1,
                        width: '100%',
                        height: '100%',
                    }}
                >
                    <TouchableOpacity
                        style={{
                            position: 'absolute',
                            top: 50,
                            left: 20,
                            zIndex: 1,
                        }}
                        onPress={() => {
                            setCamera(false)
                        }}
                    >
                        <MaterialCommunityIcons name="close-circle" color="white" size={32} />
                    </TouchableOpacity>
                    <ImageBackground
                        source={{ uri: capturedImage && capturedImage.uri }}
                        style={{
                            flex: 1,
                            alignItems: 'flex-start',
                            justifyContent: 'flex-end',
                        }}
                    >
                        <TouchableOpacity style={styles.button} onPress={retakePicture}>
                            <MaterialCommunityIcons name="camera-retake-outline" color="#6c387a" size={48} />
                            <Text style={{ fontSize: 12, marginTop: -5 }}>Retake?</Text>
                        </TouchableOpacity>
                        <TouchableOpacity style={styles.button} onPress={savePicture}>
                            <MaterialCommunityIcons name="content-save" color="#6c387a" size={48} />
                            <Text style={{ fontSize: 12, marginTop: -5 }}>Save</Text>
                        </TouchableOpacity>
                    </ImageBackground>
                </View>
            ) : (
                <Camera style={styles.camera} ref={cameraRef}>
                    <TouchableOpacity
                        style={{
                            position: 'absolute',
                            top: 50,
                            left: 20,
                            zIndex: 1,
                        }}
                        onPress={() => {
                            setCamera(false)
                        }}
                    >
                        <MaterialCommunityIcons name="close-circle" color="white" size={32} />
                    </TouchableOpacity>
                    <View style={styles.buttonContainer}>
                        <TouchableOpacity style={styles.button} onPress={takePicture}>
                            <Image style={styles.buttonLogo} source={require('../../assets/logos/ZHOnly.png')} />
                        </TouchableOpacity>
                    </View>
                </Camera>
            )}
        </View>
    )
}

export default UseCamera

const styles = StyleSheet.create({
    container: {
        flex: 1,
        justifyContent: 'center',
    },
    camera: {
        flex: 1,
    },
    buttonContainer: {
        flex: 1,
        flexDirection: 'row',
        backgroundColor: 'transparent',
        margin: 48,
        alignItems: 'center',
        justifyContent: 'center',
    },
    button: {
        alignSelf: 'flex-end',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'white',
        borderRadius: 50,
        height: 100,
        width: 100,
        borderColor: '#6c387a',
        borderWidth: 10,
        marginBottom: 20,
        marginRight: 20,
    },
    buttonLogo: {
        width: 70,
        height: undefined,
        aspectRatio: 205 / 152,
    },
})
